import React from 'react';
import { useT } from '../../../i18n';
import { Icon } from '../../../components/ui';
import { Feature } from './features';
import FeatureVisual from './FeatureVisual';

// Carte d'une fonctionnalité : animation, titre, phrase et ce qui est inclus.
const FeatureCard: React.FC<{ feature: Feature }> = ({ feature: f }) => {
  const t = useT();
  return (
    <div className={`mk-feature${f.soon ? ' soon' : ''}`}>
      <FeatureVisual id={f.visual} />
      <div className="mk-feature-body">
        <h3>
          {t(f.title)}
          {f.soon && <span className="mk-soon">{t('Bientôt')}</span>}
        </h3>
        <p>{t(f.text)}</p>
        {f.points.length > 0 && (
          <ul className="mk-feature-points">
            {f.points.map((point) => (
              <li key={point}>
                <Icon name="check" size={16} strokeWidth={2.4} />
                {t(point)}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FeatureCard;
